import moment from 'moment';
import 'moment-timezone';

export function asUTCDate(ts) {
  if (!ts) {
    return ts;
  }

  const date = new Date(ts);

  if (ts[ts.length - 1] === 'Z') {
    return date;
  }

  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
}

export function toTimezone(date, timezoneName) {
  const dateMoment = moment(date);

  if (!timezoneName) {
    return dateMoment;
  }

  return dateMoment.tz(timezoneName);
}

export function toCityTimezone(date, city) {
  return toTimezone(date, city && city.timezoneName);
}



// WEBPACK FOOTER //
// ./src/utils/dates.js